export enum DOWNLOAD_TYPES {
  DOWNLOADING_ALLOWED = "downloading_allowed",
  DOWNLOADING = "downloading",
  DOWNLOADED = "downloaded",
  DOWNLOADING_ERROR = "downloading_error",
}
